export type EventHandler = (event?: any) => void;
export type EventHandlerList = EventHandler[];
export interface IEventHandlerMap {
  [type: string]: EventHandlerList;
}

export default class EventEmitter {
  private all: IEventHandlerMap;

  constructor(allAsParam?: IEventHandlerMap) {
    this.all = allAsParam || {};
  }

  on(type: string, handler: EventHandler) {
    (this.all[type] || (this.all[type] = [])).push(handler);
  }

  off(type: string, handler: EventHandler) {
    if (this.all[type]) {
      this.all[type] = this.all[type].filter(h => h !== handler);
    }
  }

  emit(type: string, event: any) {
    (this.all[type] || []).forEach(handler => {
      handler(event);
    });
  }
}
